// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
async.push(["ready", function() {

    // $('#list').on('click', function(event) {
    //     event.preventDefault();
    //     $('.list-vehicles .item').addClass('list-group-item');
    //     $('.list-vehicles #list').addClass('active');
    //     $('.list-vehicles #grid').removeClass('active');
    //     Cookies.set('listview', 'list');
    // });

    // $('#grid').on('click', function(event) {
    //     event.preventDefault();
    //     $('.list-vehicles .item').removeClass('list-group-item');
    //     $('.list-vehicles .item').addClass('grid-group-item');
    //     $('.list-vehicles #grid').addClass('active');
    //     $('.list-vehicles #list').removeClass('active');
    //     Cookies.set('listview', 'grid');
    // });

    var windowWidth = $(window).width();
    if (windowWidth > 1440) {
        // force list view to grids
        $('#grid').trigger('click');
    }

    $('#listing-accordion .panel-collapse').on('show.bs.collapse', function(e) {
        var $panel = $(this).closest('.panel');
        var $open = $(this).closest('.panel-group').find('.panel-collapse.in');

        var additionalOffset = 60;
        if ($panel.prevAll().filter($open.closest('.panel')).length !== 0) {
            additionalOffset += $open.height();
        }

        $('html,body').animate({
            scrollTop: $panel.offset().top - additionalOffset
        }, 500);
    });
}]);